import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Apprentissage",
  "lead": "Dans au moins 15 pays d’Afrique subsaharienne, plus de la moitié des élèves n’atteignent pas le niveau minimum de compétence en lecture à la fin de l’enseignement primaire."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Scolariser les enfants ne suffit pas. Sans négliger les nombreux autres buts légitimes poursuivis par les écoles ou qui devraient l’être, il est indispensable que les élèves soient capables de lire et d’effectuer des calculs de base. Ces compétences sont le fondement des autres apprentissages, de l’autonomisation et du bien être des individus, ainsi que des réalisations sociales, politiques et économiques."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "enfants-et-jeunes",
      children: "Enfants et jeunes"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: [_jsxs(_components.p, {
        children: ["Dans certains des pays les plus pauvres du monde, de nombreux enfants ne possèdent pas les compétences élémentaires en lecture et en mathématiques. Selon des évaluations de la lecture dans les petites classes – réalisées dans des États du Nord du Nigéria, comme le Kaduna et le Sokoto, ainsi que dans des provinces de la République démocratique du Congo, comme celles de l’Équateur et du Katanga, par exemple – plus de 80 % des élèves de 3e année d’école primaire ne savaient même pas déchiffrer un ", _jsx(_components.strong, {
          children: "mot isolé"
        }), " dans un texte suivi."]
      }), _jsx(Figure, {
        id: "EGRA"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Ces données ne prennent pas en compte les enfants non scolarisés. Les enquêtes menées auprès des ménages permettent de mettre en évidence les compétences des enfants qu’ils soient scolarisés ou non."
    }), "\n", _jsx(_components.p, {
      children: "Ainsi, les graphiques ci-après, qui portent sur plusieurs régions d’Inde et du Pakistan, ont été établis à partir d’évaluations menées par des citoyens."
    }), "\n", _jsxs(_components.p, {
      children: ["Les ", _jsx(HighlightByIndex, {
        index: "1",
        children: "lignes rouges"
      }), " représentent le pourcentage d’enfants ", _jsx(_components.strong, {
        children: "scolarisés"
      }), " qui possèdent des compétences de base en lecture par année d’étude, tandis que les lignes bleues représentent le pourcentage de l’ensemble des enfants possédant des compétences de base en lecture, ", _jsx(_components.strong, {
        children: "qu’ils soient scolarisés ou non, selon l’âge qui correspond à leur année d’étude"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Les écarts qui séparent les deux lignes rappellent que dans les pays où le taux de déscolarisation est élevé, les responsables politiques qui se contentent de surveiller l’apprentissage des enfants scolarisés n’ont qu’une vision partielle de la situation. Il convient de noter que le niveau de compétences examiné est très bas. Même dans les régions affichant les meilleurs résultats, certains adolescents qui suivent des études secondaires sont incapables de lire un texte de deuxième année."
    }), "\n", _jsx(Figure, {
      id: "LEARN_AGE_GRADE"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: _jsx(_components.p, {
        children: "On estime que près de 40 % des élèves de l’enseignement primaire ne possèdent pas les compétences de base en matière de lecture. Ce chiffre s’élève à 70 % en Afrique subsaharienne, mais ne représente que 3 % en Europe et en Amérique du Nord."
      })
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.0",
      label: "4.1.0",
      children: [_jsx(_components.p, {
        children: "Dans de nombreux pays, il n'y a aucune garantie que les enfants pourront lire, et ce même en ayant terminé l'école primaire. Au niveau mondial, parmi ceux qui ont terminé l’éducation primaire, quatre enfants sur dix ne possèdent pas les compétences de base en lecture. Ce chiffre passe à huit sur dix dans les pays à faible revenu, comme le montre le graphique ci-dessous."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LEARN_REACHFINAL"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Les ", _jsx(HighlightByIndex, {
              index: "-1",
              children: "parties grises"
            }), " indiquent le pourcentage d’enfants qui ont achevé l’école primaire sans avoir atteint le niveau minimum de compétences en lecture. Les ", _jsx(HighlightByIndex, {
              index: "1",
              children: "parties rouges"
            }), " représentent les élèves qui achèvent l’enseignement primaire en ayant atteint un niveau minimum de compétences, et les ", _jsx(HighlightByIndex, {
              index: "0",
              children: "parties bleues"
            }), " les enfants qui n’achèvent pas l’enseignement primaire."]
          })
        })]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Si l’on se place à l’échelle des pays, au Benín et au Nigéria, environ 85 % des jeunes ayant arrêté l’école après cinq ou six années d’études sont analphabètes. Certains pays affichent toutefois de meilleurs résultats. Au Costa Rica et au Rwanda, par exemple, la quasi-totalité des élèves qui ont arrêté l’école après la cinquième ou la sixième année savaient lire et écrire."
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "LITBYYRS"
        })
      }), _jsx(ScrollySection, {
        id: "KEN",
        children: _jsxs(_components.p, {
          children: ["Au ", _jsx(_components.strong, {
            children: "Kenya"
          }), ", par exemple, un sur quatre des élèves savent lire et écrire ", _jsx(HighlightByIndex, {
            index: "1",
            children: "avec jusqu’à quatre ans de scolarité"
          }), ", mais ce chiffre grimpe à plus de trois sur quatre parmi ceux qui vont à l’école pendant ", _jsx(HighlightByIndex, {
            index: "0",
            children: "cinq ou six ans"
          }), ", soit l’équivalent de l’enseignement primaire."]
        })
      }), _jsx(ScrollySection, {
        id: "BFA",
        children: _jsxs(_components.p, {
          children: ["Au ", _jsx(_components.strong, {
            children: "Burkina Faso"
          }), ", très peu d’enfants savent lire ", _jsx(HighlightByIndex, {
            index: "1",
            children: "avec jusqu’à quatre ans de scolarité"
          }), ", mais plus que la moitié d’entre eux acquièrent les compétences de base en lecture et en écriture s’ils suivent ", _jsx(HighlightByIndex, {
            index: "0",
            children: "jusqu’à son terme le cycle de l’enseignement primaire"
          }), "."]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "Pour que l’apprentissage puisse être comparé d’un pays à l’autre, les évaluations ou les tests réalisés doivent être comparés à l’aide de normes internationales utilisant une même définition. Des normes de ce type ont été récemment mises en place aux fins des évaluations transnationales, dans le cadre desquelles des étudiants de pays différents passent le même test. Mais les mises en correspondance de ce genre sont bien plus rares en ce qui concerne les évaluations nationales."
    }), "\n", _jsx(_components.p, {
      children: "L’Étude internationale sur les tendances de l'enseignement des sciences et des mathématiques (TIMSS), évaluation qui a lieu tous les quatre ans, permet de suivre les progrès des élèves de quatrième et de huitième années dans le temps. Elle permet d’observer dans quels domaines les progrès sont particulièrement lents. Aux États-Unis, par exemple, le pourcentage d’élèves de huitième année atteignant le niveau minimum en matière de mathématiques est passé de 61 % en 1995 à 70 % seulement en 2015, avant de chuter à 55 % en 2023."
    }), "\n", _jsxs(_components.p, {
      children: ["Certains pays, comme ", _jsx(HighlightByIndex, {
        index: "0",
        children: "la Malaisie"
      }), ", ont même vu diminuer dans le temps la proportion d’élèves atteignant les normes minimales d’apprentissage."]
    }), "\n", _jsxs(_components.p, {
      children: ["Dans d’autres pays, comme ", _jsx(HighlightByIndex, {
        index: "1",
        children: "Barheïn"
      }), ", les progrès ont été rapides : la proportion d’élèves atteignant le niveau minimum de compétences a plus que triplé entre 2003 et 2019, avant de diminuer en 2023, conformément aux tendances observées dans de nombreux pays."]
    }), "\n", _jsx(Figure, {
      id: "PIRLSGAIN"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1b",
      children: [_jsx(_components.p, {
        children: "Contrairement à ce que l’on pourrait penser, les écarts d’apprentissage entre les sexes ne sont pas si profonds : ils ne dépassent pas dix points de pourcentage dans presque tous les pays dans l’enseignement primaire, par exemple."
      }), _jsx(_components.p, {
        children: "Mais les écarts d’apprentissage entre pays sont immenses. Dans les pays d’Afrique subsaharienne, qui se situent généralement en bas de l’échelle pour ce qui est des compétences en lecture dans l’enseignement primaire, la proportion d’élèves atteignant le niveau minimum de compétences s’étend de seulement 5 % au Burundi à 76 % au Gabon (ces deux exemples sont tirés du PASEC 2019)."
      }), _jsx(_components.p, {
        children: "En ce qui concerne les mathématiques dans l’enseignement primaire, dans les pays du sud-est asiatique, les taux de réussite s’étendent de seulement 17% en RDP lao à 89% au Viet Nam (ces deux exemples sont tirés du SEA-PLM 2024)."
      }), _jsx(Figure, {
        id: "ASSESS"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "adultes",
      children: "Adultes"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.2",
      children: [_jsx(_components.p, {
        children: "Entre 2000 et 2024, le pourcentage d’adultes sachant lire et écrire est passé de 81 % à 88 % au niveau mondial, tandis que le pourcentage de jeunes sachant lire et écrire passait de 87 % à 93 %."
      }), _jsx(_components.p, {
        children: "Malgré ces progrès, l’analphabétisme demeure très répandu dans de nombreux pays, en particulier chez les femmes. En Amérique latine et dans les Caraïbes, le ralentissement des progrès à des niveaux relativement élevés témoigne de la persistance d’îlots constitués de groupes extrêmement défavorisés et « difficiles à atteindre ». En Équateur, par exemple, le taux d’alphabétisation des femmes adultes dans les zones rurales a peu évolué au cours des 20 dernières années, passant de 81 % en 2001 à 87 % en 2024."
      }), _jsx(_components.p, {
        children: "En Afrique subsaharienne, plus de 40% des femmes adultes (25 à 64 ans) ne savent pas lire. Dans des nombreux pays, les progrès se sont arrêtés à des niveaux très bas – comme au Mali, où moins de 17 % d’entre elles savent lire – ou ont été très lents – comme à Madagascar, qui est passé de 66 % à 69 % en 20 ans."
      }), _jsx(_components.p, {
        children: "Dans l’ensemble, si le nombre d’adultes sachant lire et écrire est plus élevé aujourd’hui qu’il ne l’a été, c’est avant tout parce que davantage d’adultes ont été scolarisés dans leur jeunesse, et non parce que des adultes n’ayant jamais été à l’école ont eu une deuxième chance en matière d’apprentissage. Pour vérifier cette affirmation, le graphique ci-dessous présente des données qui permettent de suivre les compétences en lecture et en écriture d’une cohorte donnée – ou groupe – à mesure qu’elle vieillit."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "LITCOHORT"
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["Dans la plupart des pays, le taux d’alphabétisation au sein de certaines ", _jsx(HighlightByIndex, {
              index: "0",
              children: "cohortes d’adultes"
            }), " a stagné voire reculé au fil du temps lorsque ces compétences n’étaient pas suffisamment utilisées."]
          })
        }), _jsx(ScrollySection, {
          children: _jsxs(_components.p, {
            children: ["À ", _jsx(_components.strong, {
              children: "Burkina Faso"
            }), ", la ligne bleue indique que le taux d’alphabétisation des ", _jsx(HighlightByIndex, {
              index: "0",
              children: "femmes âgées de 20 à 34 ans en 2003"
            }), " >, ", _jsx(HighlightByIndex, {
              index: "0",
              children: "de 27 à 41 ans en 2010"
            }), " et ", _jsx(HighlightByIndex, {
              index: "0",
              children: "de 38 à 62 ans en 2021"
            }), " est restée relativement stable. Et cependant, étant donné que davantage de jeunes femmes savent lire et écrire, la ligne rouge montre une augmentation du ", _jsx(HighlightByIndex, {
              index: "1",
              children: "taux d’alphabétisation global chez les femmes âgées de 20 à 34 ans"
            }), " au fil du temps."]
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.6.1",
      children: [_jsx(_components.p, {
        children: "Les compétences en lecture et en écriture mesurées par ces évaluations sont élémentaires. Il s’agit d’indiquer si une personne est capable de lire une phrase simple. L’alphabétisation fonctionnelle, qui permet de lire et d’interpréter des instructions écrites, des courriers officiels ou des contrats, est une notion différente."
      }), _jsx(_components.p, {
        children: "Peu d’enquêtes internationales recueillent des données en matière d’alphabétisation fonctionnelle, encore moins de manière régulière."
      }), _jsx(_components.p, {
        children: "D’après les données dont nous disposons, nous observons que 1 adulte sur 10 en France, en Italie et en Nouvelle‑Zélande, et un sur quatre au Chili, ne sont pas alphabétisés d’un point de vue fonctionnel (autrement dit, n’atteignent pas le niveau 1 de compétences)."
      }), _jsx(Figure, {
        id: "LITPROF"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "conclusion",
      children: "Conclusion"
    }), "\n", _jsx(_components.p, {
      children: "Bien que l’ODD 4 mette désormais l’accent sur le suivi de l’apprentissage, bon nombre de pays ne transmettent toujours pas de données concernant les indicateurs relatifs aux résultats d’apprentissage en lecture et en mathématiques. Même les pays qui souhaitent commencer à évaluer l’apprentissage et à en rendre compte rencontrent souvent des obstacles qui les empêchent d’adopter des solutions efficaces et économiques. Mais les données dont nous disposons suggèrent que la plupart des élèves des pays les plus pauvres du monde n’atteignent pas le niveau minimum d’aptitude s’agissant des compétences les plus élémentaires."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://openknowledge.worldbank.org/handle/10986/32553?locale-attribute=fr",
            children: "Ending learning poverty – what will it take? – World Bank"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "http://uis.unesco.org/sites/default/files/documents/ip61-combining-data-out-of-school-children-completion-learning-offer-more-comprehensive-view-sdg4.pdf",
            children: "Combining Data on Out-of-School Children, Completion and Learning to Offer a More Comprehensive View on SDG 4 – UIS"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://gemreportunesco.wordpress.com/2019/05/20/the-learning-assessment-market-pointers-for-countries-part-2/",
            children: "The learning assessment market - pointers for countries"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
